import { render, staticRenderFns } from "./goback.vue?vue&type=template&id=d97706f4&scoped=true&"
import script from "./goback.vue?vue&type=script&lang=js&"
export * from "./goback.vue?vue&type=script&lang=js&"
import style0 from "./goback.vue?vue&type=style&index=0&id=d97706f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97706f4",
  null
  
)

export default component.exports